/**
 * Presentation Layer - FileInfoDisplay Component
 * ファイル情報表示コンポーネント
 */

import React from 'react';
import { Alert, Typography } from '@mui/material';
import type { CsvFile } from '../../../../domain/medicalReservation/CsvFile';
import type { CsvData } from '../../../../domain/medicalReservation/CsvData';

/**
 * Props定義
 */
export interface FileInfoDisplayProps {
  /** CSVファイル情報 */
  csvFile: CsvFile | null;
  /** CSVデータ情報 */
  csvData: CsvData | null;
}

/**
 * ファイル情報表示コンポーネント
 */
export const FileInfoDisplay: React.FC<FileInfoDisplayProps> = ({
  csvFile,
}) => {
  if (!csvFile) {
    return null;
  }

  return (
    <Alert severity="info">
      <Typography variant="body2">
        <strong>ファイル名:</strong> {csvFile.name}
      </Typography>
      <Typography variant="body2">
        <strong>サイズ:</strong> {(csvFile.size / 1024).toFixed(2)} KB
      </Typography>
    </Alert>
  );
};
